import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: indent * 0.8,
    flex: 1,
  },
  image: {
    aspectRatio: 1.35,
  },
  separator: {
    height: 16,
  },
});
